export default __webpack_public_path__ + "static/media/manager_effectiveness.b0ac1e30.png";